import { render } from "./EditorBAPVA.vue?vue&type=template&id=76c343ac&scoped=true"
import script from "./EditorBAPVA.vue?vue&type=script&lang=js"
export * from "./EditorBAPVA.vue?vue&type=script&lang=js"

import "./EditorBAPVA.vue?vue&type=style&index=0&id=76c343ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c343ac"]])

export default __exports__